import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMapContext } from '../../../context/MapContext';
import styled from 'styled-components';
import RealDealListTransition from './RealDealListTransition';
import { useEffect, useRef, useState } from 'react';
import {
  formatDate3,
  formatToKoreanCurrency,
  transNum2,
} from '../../../func/func';
import MapService from '../../../service/map/Map';
import { getColorByCategory } from '../MapMarkers';
const RealDealList = () => {
  const {
    iidx,
    onRealDealList,
    modalOn,
    setOnRealDealList,
    makerType,
    makerCategory,
  } = useMapContext();
  const [searchParams] = useSearchParams();
  const url_iidx = searchParams.get('iidx');
  const url_makerType = searchParams.get('makerType');
  const url_makerCategory = searchParams.get('makerCategory');
  const [areaList, setAreaList] = useState<{ area: number }[]>([]);
  const [selectedArea, setSelectedArea] = useState<any>();
  const [realDealData, setRealDealData] = useState<any[]>([]);
  const [graphData, setGraphData] = useState<any[]>([]);
  const [saleTab, setSaleTab] = useState('S');
  const [yearTab, setYearTab] = useState('A');
  const [width, setWidth] = useState('');
  const [address, setAddress] = useState('');
  const [listIidx, setListIidx] = useState(0);
  const [listType, setListType] = useState('');
  const [listCategory, setListCategory] = useState('');

  const getMarkerArea = async () => {
    if (!listIidx) return;
    const result = await MapService.realDealDataArea(
      listType,
      listIidx,
      saleTab,
    );
    setAreaList(result.data.length > 0 ? result.data : [{ area: 0 }]);
    setSelectedArea(result.data.length > 0 ? result.data[0].area : 0);
  };
  const GetRealDealPriceList = async () => {
    const result = await MapService.realDealList(
      listType,
      listIidx,
      saleTab,
      yearTab,
      selectedArea,
    );
    setAddress(result.data.address);
    setRealDealData(result.data.list);
    setGraphData(result.data.graph);
  };

  useEffect(() => {
    // setWidth(modalOn ? '460px' : url_iidx ? '100%' : '460px');
    //iidx
    setListIidx(url_iidx ? Number(url_iidx) : iidx);
    //type
    let tmpType = url_makerType ? url_makerType : makerType;
    const type = ['a', 'p', 'e'].includes(tmpType?.toLowerCase())
      ? 'A'
      : tmpType.toLowerCase() === 'r' || tmpType === 'R'
        ? 'S'
        : tmpType.trim();
    setListType(type);
    setSaleTab(type === 'A' || type === 'S' ? 'S' : tmpType.trim());
    //category
    setListCategory(url_makerCategory ? url_makerCategory : makerCategory);
  }, []);

  useEffect(() => {
    if (listIidx) {
      // ✅ API 호출 전에 areaList, selectedArea 초기화
      setAreaList([]);
      setSelectedArea(null);

      getMarkerArea();
    }
  }, [listIidx, saleTab]);

  useEffect(() => {
    if (!listIidx || selectedArea === null) {
      return;
    }

    GetRealDealPriceList();
  }, [selectedArea, yearTab]);

  const navigate = useNavigate();

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(
        `${window.location.origin}/item/realDealList/?iidx=${listIidx}&makerType=${listType}&makerCategory=${listCategory}`,
      )
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  // saleTab 변경 처리 함수
  const handleSaleTabChange = (newSaleTab: string) => {
    if (listType === 'A') {
      setSaleTab(newSaleTab);
    } else {
      setListType(newSaleTab);
      setSaleTab(newSaleTab);
    }
  };

  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
        setOnRealDealList(false);
      }}
      modalOn={modalOn}
    >
      <Inner
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Header>
          <TitleBox>
            <TitleContentBox>
              <div>
                <img src={`${getColorByCategory(listCategory).icon}`} alt="" />
              </div>
              <div>{address ?? ''}</div>
            </TitleContentBox>
            <TitleButtonBox>
              {/* <div onClick={handleCopyAddress}>
                <img src="/assets/images/icon/share.svg"></img>
              </div> */}
              <div
                onClick={() => {
                  modalOn
                    ? setOnRealDealList(false)
                    : navigate('/', { replace: true });
                }}
              >
                <img src="/assets/images/icon/close-black.svg" alt="" />
              </div>
            </TitleButtonBox>
          </TitleBox>
          <HeaderTabBox>
            <TabBox
              onClick={() => {
                setSaleTab('S');
              }}
              IsActive={saleTab === 'S'}
            >
              매매
            </TabBox>
            <TabBox
              onClick={() => {
                setSaleTab('D');
              }}
              IsActive={saleTab === 'D'}
            >
              전세
            </TabBox>
            <TabBox
              onClick={() => {
                setSaleTab('M');
              }}
              IsActive={saleTab === 'M'}
            >
              월세
            </TabBox>
          </HeaderTabBox>
        </Header>
        <ContentWrapper>
          {realDealData.length > 0 ? (
            <ContentInner>
              <YearButtonWrapper>
                <YearButtonBox>
                  <YearButton
                    onClick={() => {
                      setYearTab('A');
                    }}
                    isActive={yearTab === 'A'}
                  >
                    3년
                  </YearButton>
                  <YearButton
                    onClick={() => {
                      setYearTab('B');
                    }}
                    isActive={yearTab === 'B'}
                  >
                    5년
                  </YearButton>
                  <YearButton
                    onClick={() => {
                      setYearTab('C');
                    }}
                    isActive={yearTab === 'C'}
                  >
                    전체
                  </YearButton>
                </YearButtonBox>
              </YearButtonWrapper>
              <RealDealContentWrapper>
                <RealDealContentHeaderBox>
                  <div>지난 실거래가 흐름</div>
                  <AreaSelectBox>
                    <AreaSelect
                      onChange={(e) => {
                        const value = e.target.value;
                        const selectedValue = areaList.find(
                          (v) => v.area === Number(e.target.value),
                        );
                        setSelectedArea(selectedValue?.area);
                      }}
                      value={selectedArea || '-'}
                    >
                      {areaList.map((item, index) => (
                        <option key={index} value={item.area}>
                          {item.area === 0 ? `전체` : `${item.area}m²`}
                        </option>
                      ))}
                    </AreaSelect>
                  </AreaSelectBox>
                </RealDealContentHeaderBox>
                {saleTab !== 'M' && (
                  <RealDealGraphBox>
                    <RealDealListTransition
                      data={graphData}
                      saleTab={saleTab}
                      yearTab={yearTab}
                    ></RealDealListTransition>
                  </RealDealGraphBox>
                )}
                <RealDealDataBox>
                  <RealDealDataHeaderBox>
                    <RealDealDataHeader width={'20%'}>날짜</RealDealDataHeader>
                    <RealDealDataHeader width={'40%'}>
                      실거래가
                    </RealDealDataHeader>
                    <RealDealDataHeader width={'20%'}>면적</RealDealDataHeader>
                    <RealDealDataHeader width={'20%'}>층수</RealDealDataHeader>
                  </RealDealDataHeaderBox>
                  <RealDealDataListBox>
                    {realDealData &&
                      realDealData.map((item, index) => (
                        <RealDealDataList key={index}>
                          <RealDealData width={'20%'}>
                            {item.dealdate}
                          </RealDealData>
                          <RealDealData width={'40%'}>
                            {saleTab === 'M'
                              ? `${transNum2(Number(item.dealprice))}/${transNum2(Number(item.month_price))}`
                              : transNum2(Number(item.dealprice))}
                          </RealDealData>
                          <RealDealData width={'20%'}>
                            {item.area}m²
                          </RealDealData>
                          <RealDealData width={'20%'}>
                            {item.floor}층
                          </RealDealData>
                        </RealDealDataList>
                      ))}
                  </RealDealDataListBox>
                </RealDealDataBox>
              </RealDealContentWrapper>
            </ContentInner>
          ) : (
            <ContentInner>
              <YearButtonWrapper>
                <YearButtonBox>
                  <YearButton
                    onClick={() => {
                      setYearTab('A');
                    }}
                    isActive={yearTab === 'A'}
                  >
                    3년
                  </YearButton>
                  <YearButton
                    onClick={() => {
                      setYearTab('B');
                    }}
                    isActive={yearTab === 'B'}
                  >
                    5년
                  </YearButton>
                  <YearButton
                    onClick={() => {
                      setYearTab('C');
                    }}
                    isActive={yearTab === 'C'}
                  >
                    전체
                  </YearButton>
                </YearButtonBox>
              </YearButtonWrapper>
              <RealDealContentWrapper>
                <RealDealContentHeaderBox
                  style={{ justifyContent: 'flex-end' }}
                >
                  <AreaSelectBox>
                    <AreaSelect
                      onChange={(e) => {
                        const value = e.target.value;
                        const selectedValue = areaList.find(
                          (v) => v.area === Number(e.target.value),
                        );
                        if (selectedValue) {
                          setSelectedArea(selectedValue.area);
                        }
                      }}
                      value={selectedArea || ''}
                    >
                      {areaList.map((item, index) => (
                        <option key={index} value={item.area}>
                          {item.area === 0 ? `전체` : `${item.area}m²`}
                        </option>
                      ))}
                    </AreaSelect>
                  </AreaSelectBox>
                </RealDealContentHeaderBox>
                <RealDealDataBox>
                  <RealDealDataHeaderBox>
                    <RealDealDataHeader width={'20%'}>날짜</RealDealDataHeader>
                    <RealDealDataHeader width={'40%'}>
                      실거래가
                    </RealDealDataHeader>
                    <RealDealDataHeader width={'20%'}>면적</RealDealDataHeader>
                    <RealDealDataHeader width={'20%'}>층수</RealDealDataHeader>
                  </RealDealDataHeaderBox>
                  <RealDealDataListBox>
                    <NoDataBox>실거래가 정보가 없습니다.</NoDataBox>
                  </RealDealDataListBox>
                </RealDealDataBox>
              </RealDealContentWrapper>
            </ContentInner>
          )}
        </ContentWrapper>
      </Inner>
    </Container>
  );
};

export default RealDealList;

const NoDataBox = styled.div`
  width: 100%;
  height: 100%;
  color: #616161;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

interface RealDealDataProps {
  width: string;
}
const RealDealData = styled.div<RealDealDataProps>`
  width: ${(props) => props.width};
  text-align: center;

  //   color: #616161;
  color: ${(props) => (props.width === '40%' ? '#222222' : '#616161')};
  font-weight: ${(props) => (props.width === '40%' ? '700' : '500')};
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const RealDealDataList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 16px 0px;
`;

const RealDealDataListBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AreaSelect = styled.select`
  width: 96%;
  border: none;
  color: #616161;
  outline: none;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
`;

const AreaSelectBox = styled.div`
  width: 140px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  line-height: 22px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
  background-color: white;
  border: 1px solid rgba(23, 30, 38, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface RealDealDataHeaderProps {
  width: string;
}

const RealDealDataHeader = styled.div<RealDealDataHeaderProps>`
  width: ${(props) => props.width};
`;

const RealDealDataHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 0px;
  width: 100%;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.05);
  justify-content: center;
  align-items: center;
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;

  div {
    text-align: center;
  }
`;

const RealDealDataBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
  width: 100%;
  height: 100%;
`;

const RealDealGraphBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
  height: 164px;
`;

const RealDealContentHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const RealDealContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface YearButtonProps {
  isActive: boolean;
}

const YearButton = styled.div<YearButtonProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding: 8px 16px;
  //   background-color: rgba(112, 115, 124, 0.05);
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;

  background-color: ${(props) =>
    props.isActive ? 'white' : 'rgba(112, 115, 124, 0.05)'};
  border-radius: ${(props) => (props.isActive ? '8px' : '0px')};
  color: ${(props) => (props.isActive ? '#222222' : '#989BA2')};
`;

const YearButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding: 4px;
  background-color: rgba(112, 115, 124, 0.05);
`;

const YearButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
`;

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
`;
const ContentWrapper = styled.div`
  width: 100%;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

interface TabContentProps {
  IsActive: boolean;
}

const TabBox = styled.div<TabContentProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px;

  color: ${(props) => (props.IsActive ? '#222222' : '#989ba2')};
  border-bottom: ${(props) => (props.IsActive ? '2px #222222 solid' : 'none')};

  font-weight: ${(props) => (props.IsActive ? '700' : '500')};
  font-size: 16px;
  font-family: 'Spoqa Han Sans Neo';
  line-height: 24px;
  word-wrap: break-word;
  cursor: pointer;
`;

const HeaderTabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // padding: 0px 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px;
`;

const TitleContentBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  color: black;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;
  width: 100%;
  img {
    width: 24px;
    height: 24px;
  }
`;

const TitleButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  cursor: pointer;
`;

interface HeaderProps {
  width: string;
}

const Header = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  overflow-y: auto; /* 스크롤 가능하게 설정 */
`;

interface ContainerProps {
  modalOn: boolean;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  position: ${(props) => (props.modalOn ? 'fixed' : 'initial')};

  top: 0;
  left: 0;
  background-color: ${(props) =>
    props.modalOn ? 'rgba(0, 0, 0, 0.52)' : 'none'};
`;
